<template>
  <div id="app">
     <router-view/>
     <senWordTip></senWordTip>
  </div>
</template>

<script>
    import senWordTip from '@/components/tools/senWordTip.vue';
    export default {
        name: 'App',
        components: {
		senWordTip,
	},
    };
</script>

<style>
    /*@import './element-ui.scss';*/
</style>
